<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="8" style="text-align: start">
                <strong>{{ $t('components.addBanksAccounts') }}</strong>
              </CCol>
              <CCol col="4" style="text-align: end">
                <CButton v-if="status_form ==0" @click="insert_data()"
                         type="submit" class="mr-1 ml-1"
                         size="sm" color="secondary">
                  {{ $t('buttons.submit') }}
                </CButton>
                <CButton v-if="status_form !=0" @click="insert_data()"
                         type="submit" size="sm" color="secondary">
                  {{ $t('buttons.edit') }}
                </CButton>
                <CButton v-if="status_form!=0" @click="emptyList()"
                         class="mr-1"
                         type="reset" size="sm" color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>

              </CCol>
            </CRow>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol col="3">
                <CSelect :options="filtered_accounting_list_add" :label="$t('accountSarfasl')"
                         :value.sync="selected_moein"

                         :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                />
              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('components.bankAccTitle')"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    v-model="name"

                />
              </CCol>
              <CCol col="3">
                <CRow>
                  <CCol col="5" class="text-end">
                    <label class="text-end">{{$t('isSale')}}</label>
                  </CCol>
                  <CCol col="7">
                    <CIcon
                        @click.native="isSale = false"
                        v-if="isSale"
                        class="text-success" name="cil-check"/>
                    <CIcon
                        @click.native="isSale=true"
                        v-else
                        name="cil-check"/>
                  </CCol>
                </CRow>
              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('components.summary')"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    v-model="description"

                />
              </CCol>
              <CCol col="3">
                <CSelect
                    :label="$t('components.bank')"
                    :options="bank_items"
                    :value.sync="selected_bank"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                />

              </CCol>
              <CCol col="3" >
                <CInput
                    :label="$t('SortCode')"
                    v-model="sort_code"
                    :maxlength="6"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                />

              </CCol>
              <CCol col="3" >
                <CInput
                    :label="$t('AccountNo')"
                    :maxlength="8"

                    v-model="account_no"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                />

              </CCol>
              <CCol col="3">
                <CInput
                    :label="$t('components.shebaNo')"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                    v-model="sheba_no"

                />
              </CCol>
              <CCol col="3">
                <CSelect
                    :options="[{label:$t('active'),value:39},{label:$t('deactivate'),value:40}]"
                    :label="$t('components.status')"
                    :value.sync="status_value"
                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                />
              </CCol>
<!--              <CCol col="3">-->
<!--                <CInput-->
<!--                    :label="$t('components.bankAccCode')"-->
<!--                    :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->

<!--                    v-model="bank_no"-->

<!--                />-->
<!--              </CCol>-->











            </CRow>
          </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>{{ $t('components.banksAccounts') }}</strong>
          </CCardHeader>
          <CCardBody class="mb-3">
            <CRow>
              <CCol col="3">
                <CSelect :options="filtered_accounting_list" :label="$t('accountSarfasl')"
                         :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                         :value.sync="selected_cashier_type"

                />

              </CCol>
              <CCol col="3">
                <CSelect :options="[{label:$i18n.t('all'),value:0},{label:$i18n.t('active'),value:39},{label:$i18n.t('deactivate'),value:40}]"
                         :value.sync="filter_status"
                         :label="$t('tables.status')"
                         horizontal
                />
              </CCol>

            </CRow>

            <CDataTable
                :items="filtered_items"
                :fields="fields"
column-filter
                border
                striped
                :items-per-page="20"
                hover
                sorter
                pagination
            >
              <template #row="{item,index}">

                <td style="text-align: center">
                  <p >{{ index + 1 }}</p>

                </td>

              </template>
              <template #isActive="{item,index}">
                <td style="text-align: center">
                  <CIcon

                      v-if="item.isActive==39"
                      class="text-success" name="cil-check"/>
                  <CIcon

                      v-else
                      name="cil-check"/>
                </td>
              </template>
              <template #name="{item}">

                <td>
                  <p >{{ item.title }}</p>

                </td>

              </template>
              <template #bankAccCode="{item}">
                <td>
                  <p style="text-align: center">{{ item.bankAccCode }}</p>
                </td>
              </template>


              <template #sortCode="{item}">
                <td>
                  <p style="text-align: center">{{ item.sortCode }}</p>
                </td>
              </template>

              <template #accountNo="{item}">
                <td>
                  <p style="text-align: center">{{ item.accountNo }}</p>
                </td>
              </template>

              <template #summary="{item}">

                <td>
                  <p v-if="item.summary != 'null'">{{ item.summary }}</p>

                </td>

              </template>

              <template #color="{item}">

                <td>
                  <div :style="get_style(item.methodColor)">
                    {{ item.methodColor }}
                  </div>
                </td>

              </template>
              <template #isSale="{item}">

                <td>
                  <p v-if="item.isSale"> <CIcon class="text-success" name="cil-check"/></p>
                  <p v-if="!item.isSale"> <CIcon  name="cil-check"/></p>

                </td>

              </template>
              <template #operation="{item}">
                <td>
                    <CIcon @click.native="edit_item(item)"  class="text-warning" name="cilPencil"/>
                    <CIcon @click.native="delete_item_dialog(item)" class="text-danger"  name="cilTrash"/>
                </td>
              </template>


            </CDataTable>
          </CCardBody>

        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles

var items = [];


export default {
  name: 'Login',
  components: {},
  data() {
    return {
      filter_status:0,
      confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
      isSale:true,
      status_value:39,
      validate_errors: [],
      name: '',
      sort_code:'',
      account_no:'',
      description: '',
      selected_branch: '',
      selected_bank: '',
      bank_no: '',
      sheba_no: '',
      branch_items: [],
      bank_items: [],
      selected_moein:0,
      selected_cashier_type:0,
      all_accounting_list:[],
      filtered_accounting_list:[],
      filtered_accounting_list_add:[],

      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      fields: [
        {key: 'row', label: this.$t('tables.row'),sorter:false, _style: 'width:3%'},
        {key: 'bankAccCode', label: this.$t('tables.bankAccCode'), _style: 'width:10%'},
        {key: 'accountTitle', label: this.$t('accountSarfasl'), _style: 'width:10%'},

        {key: 'bankName', label: this.$t('tables.bank'), _style: 'width:10%'},

        {key: 'bankAccTitle', label: this.$t('tables.bankAccTitle'), _style: 'width:10%'},
        {key: 'sortCode', label: this.$t('SortCode'), _style: 'width:10%'},
        {key: 'accountNo', label: this.$t('AccountNo'), _style: 'width:10%'},
        // {key: 'branchName', label: this.$t('tables.branch'), _style: 'width:10%'},
        {key: 'isActive', label: this.$t('tables.status'), _style: 'width:5%'},

        {key: 'shabaNo', label: this.$t('tables.shabaNo'), _style: 'width:10%'},
        {key: 'isSale', label: this.$t('isSale'), _style: 'width:10%'},
        {key: 'summary', label: this.$t('tables.summary'), _style: 'width:10%'},
        {key: 'operation',  label: this.$t('tables.operation'),filter:false,sorter:false, _style: 'width:5%;'},
      ],
      filtered_items:[],
      status_form: 0,

    }
  },
  created() {
  },
  mounted() {
    this.$root.root_validate_errors = [];

    this.get_bank();
    this.get_branches();
    this.get_lists();
    this.get_lists_groups();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'filter_status':function (){
      this.get_lists()
    },
    '$route.params.cat_id': function () {
      this.get_lists();
    },
    'selected_cashier_type': function () {
      if (this.selected_cashier_type == 0) {
        this.filtered_items = this.items;
      }
      else {
        this.filtered_items = this.items.filter(item => item.accountId == this.selected_cashier_type);
      }
    },

  },
  methods: {
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if ( this.selected_bank != 0
           && this.sheba_no != '' && this.name != '' && this.sort_code.length==6 && this.account_no.length==8) {
        return true;
      }


      // if (this.selected_branch == 0) {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.selectBranch'));
      // }
      if (this.sort_code.length != 6 ){
        this.$root.root_validate_errors.push("sort code is 6 characters");
      }
      if (this.account_no.length != 8){
        this.$root.root_validate_errors.push("Account No is 8 characters");
      }
      if (this.selected_bank == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectBank'));
      }
      if (this.sheba_no == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertSheba'));
      }
      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertBankName'));
      }

      return false;
      // e.preventDefault();
    },

    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      this.name = item.bankAccTitle;
      this.description = item.summary;
      this.selected_branch = item.branchId;
      this.selected_bank = item.bankId;
      // this.bank_no = item.bankAccCode;
      this.sheba_no = item.shabaNo;
      this.isSale = item.isSale;
      this.sort_code= item.sortCode;
      this.account_no= item.accountNo;
      this.status_form = item.id;
      this.status_value = item.isActive

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.color = '';
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

    },
    get_lists() {
      var self = this;

      const formData = new FormData();


      formData.append('StatusId', this.filter_status);


      axios.post('GetBankAccounts', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.filtered_items = self.items;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_bank() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBanks', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.bank_items = [];
          self.bank_items = self.sort_array(self.bank_items,content_data.data,'id','bankTitle')

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.bankTitle, value: val.id}
          //
          //   self.bank_items.push(obj);
          // });
          self.selected_bank = self.bank_items[0].value
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_branches() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);


      axios.post('GetBranchList', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.branch_items = [];
          self.branch_items = self.sort_array(self.branch_items,content_data.data,'branchId','branchTitle')

          // content_data.data.forEach((val) => {
          //   var obj = {label: val.branchTitle, value: val.branchId}
          //   self.branch_items.push(obj);
          // });
          self.selected_branch = self.branch_items[0].value

        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goToMembers(item) {

      this.$router.push({path: '/dashboard/accounting/sale-method-members/' + item.id});

    },

    insert_data() {

      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }
      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddBankAccount";
      } else {
        url = "EditBankAccount";
        formData.append('Id', this.status_form)

      }
      formData.append('IsActive', this.status_value);

      formData.append('IsSale', this.isSale);
      formData.append('BankId', this.selected_bank);
      formData.append('BankAccTitle', this.name);
      // formData.append('BankAccCode', this.bank_no);
      formData.append('BranchId', this.selected_branch);
      formData.append('ShabaNo', this.sheba_no);
      formData.append('Summary', this.description);
      formData.append('AccountId', self.selected_moein);
      formData.append('SortCode', self.sort_code);
      formData.append('AccountNo', self.account_no);


      // formData.append('AreaId', this.selected_area);
      axios.post(url, formData, {}).then((res) => {

        self.status_form = 0;
        self.name = '';
        // self.bank_no = '';
        self.description = '';
        self.sheba_no = '';
        self.get_lists();

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {

      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.bankAccTitle]), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBankAccount";


      formData.append('Id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    get_lists_groups() {
      var self = this;
      self.items_parent = [];
      self.data_with_children = []

      const formData = new FormData();
      var url = "Get_AllAccountingGroups";
      // formData.append("MasterId", 0);

      // formData.append("id", 1);
      this.filtered_accounting_list=[{label:this.$t('all'),value:0}]

      axios.post(url, formData, {}).then(function (response) {

            var content_data = response.data;

            if (content_data.statusCode == 0) {


              self.all_accounting_list = response.data.data


              // console.log(self.data);
              response.data.data.forEach((val) => {
                if (val.parentId == 11) {

                  var obj = {
                    label: val.accountName,
                    name_code: val.accountName + " (" + val.accountCode + ")",
                    nature: val.nature,
                    type: val.type,
                    code: val.accountCode,
                    parentId: val.parentId,
                    value: val.id,
                    // children: self.get_childrens(val.id, response.data.data)


                  }

                  self.filtered_accounting_list.push(obj);
                  self.filtered_accounting_list_add.push(obj);


                }

              });
              self.selected_moein = self.filtered_accounting_list_add[0].value

              // self.filter_data()
            } else {
              self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

            }

          }
      )
          .catch(function (error) {
            console.log(error);
          });

    },

  }
}

</script>
